import { component } from 'picoapp';
import { addVariant } from '../../../js/lib/cart';
import Drawer from '../../../js/utils/drawer';
import formatMoney from '../../../js/utils/money';

export default component(async (node) => {
  /**
   * Data + elements
   */
  const price = node.querySelector('.js-price');
  const selectedDenomination = node.querySelector('.js-selectedDenomination');
  const denominationSelectionBtn = node.querySelector('.js-denominationSelectionBtn');
  const denominationDrawerElement = node.querySelector('.js-denominationDrawer');
  const denominationValueBtns = node.querySelectorAll('.js-denominationValueBtn');
  const denominationDrawerCloseBtn = node.querySelector('.js-denominationDrawerCloseBtn');
  const form = node.querySelector('.js-form');
  const variantSelect = node.querySelector('.js-variantSelect');
  const addToCartBtn = node.querySelector('.js-addToCartBtn');

  const productData = JSON.parse(node.querySelector('.js-productData').innerHTML);

  const config = JSON.parse(node.dataset.config);
  const { denominationOptionPosition } = config;
  /**
   * Functions
   */
  const initVariantSelection = () => {
    const selectedVariantCallback = (variant) => {
      price.textContent = formatMoney(variant.price, theme.moneyFormat);
    };

    const createShopifySelection = () => new Shopify.OptionSelectors(`product-${productData.id}`, {
      product: productData,
      onVariantSelected: selectedVariantCallback,
      enableHistoryState: true,
    });

    createShopifySelection();
  };

  const initOptionSelection = () => {
    const denominationDrawer = Drawer(denominationDrawerElement);

    denominationSelectionBtn.addEventListener('click', () => denominationDrawer.open());
    denominationDrawerCloseBtn.addEventListener('click', () => denominationDrawer.close());

    const trueOptionSelectors = node.querySelectorAll('.single-option-selector');
    const trueDenominationSelector = Array.from(trueOptionSelectors).find((selector) => parseInt(selector.dataset.option.replace('option', ''), 10) === denominationOptionPosition);

    const selectDenomination = (btn) => {
      const { value } = btn.dataset;

      selectedDenomination.textContent = value;
      selectedDenomination.dataset.value = value;

      trueDenominationSelector.value = selectedDenomination.dataset.value;

      trueOptionSelectors.forEach((selector) => selector.dispatchEvent(new Event('change')));

      addToCartBtn.disabled = false;

      denominationDrawer.close();
    };

    denominationValueBtns.forEach((btn) => {
      btn.addEventListener('click', () => selectDenomination(btn));
    });

    const updateSelectionFromVariantParam = () => {
      const params = new URLSearchParams(window.location.search);
      const variantParam = parseInt(params.get('variant'), 10);

      if (variantParam) {
        const variant = productData.variants.find((v) => v.id === variantParam);
        const denomination = variant[`option${denominationOptionPosition}`];

        const matchingDenominationValueBtn = Array.from(denominationValueBtns).find((btn) => btn.dataset.value === denomination); // eslint-disable-line
        if (matchingDenominationValueBtn) matchingDenominationValueBtn.click();
      }
    };

    updateSelectionFromVariantParam();
  };

  const initForm = () => {
    const toggleButton = (active) => {
      if(!addToCartBtn) return;
      addToCartBtn.classList[active ? 'remove' : 'add']('animate-pulse');
      addToCartBtn.querySelector('.icon').style.display = active ? '' : 'none';
      addToCartBtn.querySelector('.load-ring').style.display = !active ? '' : 'none';
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!form.reportValidity()) return;

      toggleButton(false);
      deliveryError.hidden = true;

      const variantId = variantSelect.value;

      addVariant({
        variantId,
        quantity: 1,
        properties: getDeliveryProperties(),
        callback: () => toggleButton(true),
        onError: (error) => {
          deliveryError.textContent = typeof error?.description === 'string' ? error.description : error?.message;
          deliveryError.hidden = false;
        },
      });
    });
  };

  /**
   * Send as gift - uses Shopify's native gift card recipient properties.
   * Recipient email is required when the checkbox is ticked; name, message and date are optional.
   * Without a date, Shopify sends the gift card to the recipient right after the order.
   */
  const giftToggle = node.querySelector('.js-giftCardToggle');
  const giftFields = node.querySelector('.js-giftCardFields');
  const emailInput = node.querySelector('.js-giftCardEmail');
  const nameInput = node.querySelector('.js-giftCardName');
  const messageInput = node.querySelector('.js-giftCardMessage');
  const messageCount = node.querySelector('.js-giftCardMessageCount');
  const sendOnInput = node.querySelector('.js-giftCardSendOn');
  const deliveryError = node.querySelector('.js-giftCardError');

  const toDateString = (date) => {
    const offset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - offset).toISOString().slice(0, 10);
  };

  const initDelivery = () => {
    // Earliest date is tomorrow: leaving the date empty sends the gift card immediately,
    // and Shopify allows scheduling up to 90 days ahead
    const today = new Date();
    const minDate = new Date();
    const maxDate = new Date();
    minDate.setDate(today.getDate() + 1);
    maxDate.setDate(today.getDate() + 90);
    sendOnInput.min = toDateString(minDate);
    sendOnInput.max = toDateString(maxDate);

    const syncGiftFields = () => {
      giftFields.hidden = !giftToggle.checked;
      emailInput.required = giftToggle.checked;
      deliveryError.hidden = true;
    };

    // Browsers may restore the checkbox state on back navigation
    syncGiftFields();
    giftToggle.addEventListener('change', syncGiftFields);

    messageInput.addEventListener('input', () => {
      messageCount.textContent = messageInput.value.length;
    });
  };

  const getDeliveryProperties = () => {
    if (!giftToggle.checked) return undefined;

    const properties = {
      __shopify_send_gift_card_to_recipient: 'true',
      'Recipient email': emailInput.value.trim(),
      __shopify_offset: new Date().getTimezoneOffset(),
    };

    if (nameInput.value.trim()) properties['Recipient name'] = nameInput.value.trim();
    if (messageInput.value.trim()) properties.Message = messageInput.value.trim();
    if (sendOnInput.value) properties['Send on'] = sendOnInput.value;

    return properties;
  };

  const init = () => {
    initVariantSelection();
    initOptionSelection();
    initDelivery();
    initForm();
  };

  /**
   * Init
   */
  init();
});
